export default __webpack_public_path__ + "static/media/05.df5473c3.jpg";